import { Routes } from '@angular/router';
import { HomePageComponent } from './components/pages/home-page/home-page.component';
import { DashboardPageComponent } from './components/pages/admin/dashboard-page/dashboard-page.component';
import { RegistrationPageComponent } from './components/pages/registration/registration-page/registration-page.component';
import { RegistrationCompletedPageComponent } from './components/pages/registration/registration-completed-page/registration-completed-page.component';
import { FullBackgroundPageComponent } from './components/templates/full-background-page/full-background-page.component';
import { HeaderPageLayoutComponent } from './components/templates/header-page-layout/header-page-layout.component';
import { ProfilePageComponent } from './components/pages/profile/profile-page.component';
import {
  OrganizationOverviewPageComponent,
  OrganizationDetailPageComponent,
  OrganizationEditPageComponent,
  OrganizationMemberDetailPageComponent,
  OrganizationMemberEditPageComponent,
  OrganizationMemberAddPageComponent
} from './components/pages/admin/organization';
import {
  RequestOverviewPageComponent,
  RequestAdmissionPageComponent,
  UsecaseRequestAdmissionPageComponent,
  RepresentativeChangeAdmissionPageComponent
} from './components/pages/admin/request';
import { PartnerNetworkOverviewPageComponent } from './components/pages/partnernetwork/partnernetwork-overview-page/partnernetwork-overview-page.component';
import { PartnerNetworkDetailPageComponent } from './components/pages/partnernetwork/partnernetwork-detail-page/partnernetwork-detail-page.component';
import { UseCaseDetailPageComponent } from './components/pages/use-cases/use-case-detail-page/use-case-detail-page.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    component: FullBackgroundPageComponent,
    children: [
      { path: '', component: HomePageComponent },
      { path: 'registration', component: RegistrationPageComponent },
      { path: 'registration/completed', component: RegistrationCompletedPageComponent }
    ]
  },
  {
    path: 'profile',
    component: HeaderPageLayoutComponent,
    children: [
      { path: '', component: ProfilePageComponent, data: { titleKey: 'Profil' } }
    ]
  },
  {
    path: 'use-cases',
    component: HeaderPageLayoutComponent,
    children: [
      {
        path: ':id',
        component: UseCaseDetailPageComponent,
        data: { titleKey: 'menu.usecases' }
      }
    ]
  },
  {
    path: 'partnernetwork',
    component: HeaderPageLayoutComponent,
    children: [
      {
        path: '',
        component: PartnerNetworkOverviewPageComponent,
        data: { titleKey: 'Partnernetzwerk' }
      },
      {
        path: 'details/:id',
        component: PartnerNetworkDetailPageComponent,
        data: { titleKey: 'Partnernetzwerk • Details' }
      }
    ]
  },
  {
    path: 'admin',
    component: HeaderPageLayoutComponent,
    children: [
      { path: '', component: DashboardPageComponent, data: { titleKey: 'Dashboard' } },
      { path: 'dashboard', component: DashboardPageComponent, data: { titleKey: 'Dashboard' } },
      {
        path: 'requests',
        component: RequestOverviewPageComponent,
        data: { titleKey: 'Anfragen' }
      },
      {
        path: 'requests/use-case/:id/approve',
        component: UsecaseRequestAdmissionPageComponent,
        data: { titleKey: 'Use-Case Anfrage prüfen' }
      },
      {
        path: 'requests/representative-change/:id/approve',
        component: RepresentativeChangeAdmissionPageComponent,
        data: { titleKey: 'Vertretungswechsel prüfen' }
      },
      {
        path: 'requests/:id/approve',
        component: RequestAdmissionPageComponent,
        data: { titleKey: 'Anfrage prüfen' }
      },
      {
        path: 'organizations',
        component: OrganizationOverviewPageComponent,
        data: { titleKey: 'Organisationen' }
      },
      {
        path: 'organizations/details/:id',
        component: OrganizationDetailPageComponent,
        data: { titleKey: 'Organisationen • Details' }
      },
      {
        path: 'organizations/details/:id/edit',
        component: OrganizationEditPageComponent,
        data: { titleKey: 'Organisationen • Bearbeiten' }
      },
      {
        path: 'organizations/details/:organizationId/members/add',
        component: OrganizationMemberAddPageComponent,
        data: { titleKey: 'Mitglied • Einladen' }
      },
      {
        path: 'organizations/details/:organizationId/members/:memberId',
        component: OrganizationMemberDetailPageComponent,
        data: { titleKey: 'Mitglied • Details' }
      },
      {
        path: 'organizations/details/:organizationId/members/:memberId/edit',
        component: OrganizationMemberEditPageComponent,
        data: { titleKey: 'Mitglied • Bearbeiten' }
      }
    ]
  }
];
